import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import "./B2C.css";
import Table from "react-bootstrap/Table";
import Axios from "axios";

const ManageB2C = () => {
  const [flipkart, setFlipkartData] = useState([]);
  const [amazon, setAmazonData] = useState([]);
  const [pinnacle, setPinnacleData] = useState([]);
  const [employee, setEmployeeData] = useState([]);
  const [Scrap, setScrapData] = useState([]);
  const [Snapdeal, setSnapdeal] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [totalCount, settotalCount] = useState("");
  const [tableToDisplay, setTableToDisplay] = useState(null);
   const [meesho, setMeesho] = useState([]);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getflipkartB2C`).then(
      (response) => {
        const sortedData = response.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setFlipkartData(sortedData);
      }
    );

    Axios.get(`${INVENTORY_API_BASE_URL}/getamazonB2C`).then(
      (response) => {
        const sortedData = response.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setAmazonData(sortedData);
      }
    );

    Axios.get(`${INVENTORY_API_BASE_URL}/getPinnacleB2C`).then(
      (response) => {
        const sortedData = response.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setPinnacleData(sortedData);
      }
    );

    Axios.get(`${INVENTORY_API_BASE_URL}/getMeeshoB2C`).then(
      (response) => {
        const sortedData = response.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setMeesho(sortedData);
      }
    );

    Axios.get(`${INVENTORY_API_BASE_URL}/getEmployeeB2C`).then(
      (response) => {
        const sortedData = response.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setEmployeeData(sortedData);
      }
    );

    Axios.get(`${INVENTORY_API_BASE_URL}/getScrapB2C`).then(
      (response) => {
        const sortedData = response.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setScrapData(sortedData);
      }
    );

    Axios.get(`${INVENTORY_API_BASE_URL}/getSnapdealB2C`).then(
      (response) => {
        const sortedData = response.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setSnapdeal(sortedData);
      }
    );
  }, []);

  const getFilteredData = (data) => {
    let start = startDate ? new Date(`${startDate}T00:00:00.000Z`) : null;
    let end = endDate ? new Date(`${endDate}T23:59:59.999Z`) : null;
  
    if (selectedMethod === "method4") {
      const cutoffDate = new Date("2025-05-01T23:59:59.999Z");
      return data.filter((item) => new Date(item.date) > cutoffDate);
    }
  
    return data.filter((item) => {
      const itemDate = new Date(item.date);
      if (start && itemDate < start) return false;
      if (end && itemDate > end) return false;
      return true;
    });
  };
  

  const renderTable = (data) => {
    const filteredData = getFilteredData(data);
    const count = filteredData.reduce(
      (acc, item) => acc + Number(item.count),
      0
    );
    settotalCount(count);

    return (
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Date</th>
            <th>Count</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((row, index) => (
            <tr key={index}>
              <td>{row.date}</td>
            <td>{row.barcodeData?.length ?? 0}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  useEffect(() => {
    let dataToUse;
    switch (selectedMethod) {
      case "method1":
        dataToUse = flipkart;
        break;
      case "method2":
        dataToUse = amazon;
        break;
      case "method3":
        dataToUse = pinnacle;
        break;
      case "method4":
        dataToUse = employee;
        break;
      case "method5":
        dataToUse = Scrap;
        break;
      case "method6":
        dataToUse = Snapdeal;
        break;
      case "method7":
        dataToUse = meesho;
        break;  
      default:
        dataToUse = null;
    }

    if (dataToUse) {
      setTableToDisplay(renderTable(dataToUse));
    } else {
      setTableToDisplay(<p>Select an Option to display the table.</p>);
      settotalCount("");
    }
  }, [
    selectedMethod,
    startDate,
    endDate,
    flipkart,
    amazon,
    pinnacle,
    employee,
    Scrap,
    Snapdeal,
    meesho,
  ]);

  return (
    <main className="manage-b2c-container">
      <div className="manage-b2c-content">
        <header className="manage-b2c-header">
          <div>
            <p className="manage-b2c-eyebrow">Outbound operations · B2C</p>
            <h1>Manage B2C</h1>
            <p>Review channel activity and filter outbound records by date.</p>
          </div>
          <span className="manage-b2c-header-badge">Channel reports</span>
        </header>

        <section className="manage-b2c-filter-card" aria-labelledby="manage-b2c-filter-title">
          <div className="manage-b2c-section-heading">
            <div>
              <h2 id="manage-b2c-filter-title">Report filters</h2>
              <p>Select a channel and date range to view matching records.</p>
            </div>
          </div>

          <div className="manage-b2c-filter-grid">
            <label className="manage-b2c-control">
              <span>Select B2C</span>
              <select
                className="manage-b2c-select"
                value={selectedMethod}
                onChange={(e) => setSelectedMethod(e.target.value)}
              >
                <option value="">Select Option</option>
                <option value="method1">Flipkart B2C</option>
                <option value="method2">Amazon B2C</option>
                <option value="method3">Pinnacle B2C</option>
                <option value="method4">Youtube Influencer</option>
                <option value="method5">Scrap B2C</option>
                <option value="method6">Snapdeal B2C</option>
                <option value="method7">Meesho B2C</option>
              </select>
            </label>

            <label className="manage-b2c-control">
              <span>From date</span>
              <input
                type="date"
                value={startDate}
                aria-label="Filter from date"
                onChange={(e) => setStartDate(e.target.value)}
              />
            </label>

            <label className="manage-b2c-control">
              <span>To date</span>
              <input
                type="date"
                value={endDate}
                aria-label="Filter to date"
                onChange={(e) => setEndDate(e.target.value)}
              />
            </label>

            <div className="manage-b2c-total-card" aria-live="polite">
              <span>Total outbound count</span>
              <strong>{totalCount}</strong>
            </div>
          </div>
        </section>

        <section className="manage-b2c-results-card" aria-label="Outbound records">
          <div className="manage-b2c-results-heading">
            <div>
              <h2>Outbound activity</h2>
              <p>Records for the selected sales channel and date range.</p>
            </div>
          </div>
          <div className="manage-b2c-table">{tableToDisplay}</div>
        </section>
      </div>
    </main>
  );
};
export default ManageB2C;
